/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');
var spine_core_tenant_id_pb = require('../../../spine/core/tenant_id_pb.js');
goog.exportSymbol('proto.spine.server.tenant.TenantAdded', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.tenant.TenantAdded = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.tenant.TenantAdded, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.tenant.TenantAdded.displayName = 'proto.spine.server.tenant.TenantAdded';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.tenant.TenantAdded.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.tenant.TenantAdded.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.tenant.TenantAdded} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.tenant.TenantAdded.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_core_tenant_id_pb.TenantId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.tenant.TenantAdded}
 */
proto.spine.server.tenant.TenantAdded.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.tenant.TenantAdded;
  return proto.spine.server.tenant.TenantAdded.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.tenant.TenantAdded} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.tenant.TenantAdded}
 */
proto.spine.server.tenant.TenantAdded.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_tenant_id_pb.TenantId;
      reader.readMessage(value,spine_core_tenant_id_pb.TenantId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.tenant.TenantAdded.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.tenant.TenantAdded.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.tenant.TenantAdded} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.tenant.TenantAdded.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_tenant_id_pb.TenantId.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.TenantId id = 1;
 * @return {?proto.spine.core.TenantId}
 */
proto.spine.server.tenant.TenantAdded.prototype.getId = function() {
  return /** @type{?proto.spine.core.TenantId} */ (
    jspb.Message.getWrapperField(this, spine_core_tenant_id_pb.TenantId, 1));
};


/** @param {?proto.spine.core.TenantId|undefined} value */
proto.spine.server.tenant.TenantAdded.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.tenant.TenantAdded.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.tenant.TenantAdded.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.spine.server.tenant);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../known_type_parsers.js');

proto.spine.server.tenant.TenantAdded.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.tenant.TenantAdded.fromObject(jsObject);
};

proto.spine.server.tenant.TenantAdded.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.tenant.TenantAdded();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.core.TenantId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  return msg;
};
